export default __webpack_public_path__ + "static/intelligentes-design_boge-industriekompressoren-155fbfc4fcf36ad961489fb5302a5492.png";